import SupplierForm from 'Forms/Supplier/Main';
import Layout from 'layouts/TabForm';
import React from 'react';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useGetId } from 'utils/hooks';
import { goto, MODS } from 'utils/structure';

export default function Save() {
  const save = useGetId();
  const history = useHistory();

  return (
    <Layout
      component={SupplierForm}
      options={save}
      onCreate={data => {
        Swal.fire({
          icon: 'success',
          title: 'Creado',
          text: 'Proveedor agregado.',
        });
        history.push(`${goto(MODS.SUPPLIERS)}/${data.id}`);
      }}
      onUpdate={() => {
        Swal.fire({
          icon: 'success',
          title: 'Guardado',
          text: 'Proveedor guardado.',
        });
      }}
    />
  );
}
